import * as Models from "../.";

export interface IArrayData {
    arrayDataId: number;
    tilt: number;
    orientation: number;
    numberOfPanels: number;
    annualProduction: number;
    efficiency: number;
    unshadedPercent: number;
    roofName: string;
    selectedInverter: Models.Customer.SystemComponent.SystemComponent;
    tof: number;
    arraySize: number;
    utilityProduction: string;
    actualProduction: string;
}

export class ArrayData implements IArrayData {
    arrayDataId: number;
    tilt: number;
    orientation: number;
    numberOfPanels: number;
    annualProduction: number;
    efficiency: number;
    unshadedPercent: number;
    roofName: string;
    selectedInverter: Models.Customer.SystemComponent.SystemComponent;
    tof: number;
    arraySize: number;
    utilityProduction: string;
    actualProduction: string;
}
